import { gql } from '@apollo/client';

export const cityFragment = gql`
  fragment city on City {
    id
    code
    name
    type
    parentCityId
    inactive
    siruta
    isoAlpha2
    isoAlpha3
    nameInt
    parents {
      id
      type
      name
    }
  }
`;
